<template>
  <!--
    data-auto_select="true" will attempt to sign a user in automatically...
    might be worth testing in future

    another consideration is that the one tap popup obscures both login & cart btn...
    could be worth experimenting with where we place the widget
  -->
  <div
    id="g_id_onload"
    :data-client_id="clientId"
    data-login_uri="api/users/login/google/"
    :data-redirect_uri="redirectUri"
    data-itp_support="true"
  />
</template>

<script>
import BasePageMixin from '~/mixins/base-page-mixin';

export default {
  mixins: [BasePageMixin],
  data() {
    return {
      redirectUri: '/',
    };
  },
  computed: {
    clientId() {
      return this.$env.GOOGLE_DATA_CLIENT_ID;
    },
  },
  mounted() {
    if (process.client) {
      this.redirectUri = `${window.location.pathname}${window.location.search}`;
    }
  },
};
</script>
